import Icon from '../components/Icon.vue'

Icon.register({
  'wine-glass-alt': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M216 464c22.1 0 40 17.9 40 40 0 4.4-3.6 8-8 8h-208c-4.4 0-8-3.6-8-8 0-22.1 17.9-40 40-40h40v-117.2c-68.5-15.9-118-79.9-111.4-154.2l16-178.1c0.7-8.2 7.6-14.5 15.7-14.5h223.5c8.2 0 15 6.3 15.7 14.5l16 178.1c6.6 74.3-42.9 138.3-111.4 154.2v117.2h40zM61.8 48l-7.2 80h178.8l-7.2-80h-164.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wine-glass-alt.js
// module id = 2116
// module chunks = 0